let vibe_cake_masters_notices = function( $ ) {

	let is_scrolling = false,
		scroll_speed = 700,
		anim_speed   = 400;

	let add_notice = function( $wrapper, type, message, scroll_to = false ) {
		if ( scroll_to && ! is_scrolling ) {
			$( 'html, body' ).animate({
				scrollTop: $wrapper.offset().top - 50
			}, scroll_speed );
		}

		$wrapper.find( '.notice' ).not( '.current-notice' ).slideUp( anim_speed );
		$wrapper.prepend( '<div class="masters-notice current-notice ' + type + '" style="display: none">' + message + '</div>' );

		let $current_notice = $wrapper.find( '.current-notice' );

		$current_notice.slideDown( anim_speed ).removeClass( 'current-notice' );

		setTimeout( () => {
			$current_notice.slideUp( anim_speed );
			setTimeout( () => {
				$current_notice.remove();
			}, anim_speed );
		}, 5000 );
	};

	let clear_notices = function( $wrapper ) {
		$wrapper.find( 'masters-notice' ).not( 'current-notice' ).slideUp( anim_speed );
	};

	return {
		add_notice: add_notice,
		clear_notices: clear_notices,
	}

} ( jQuery );

module.exports = vibe_cake_masters_notices;